import { FunctionReturnType } from 'convex/server';
import { api } from 'convex/_generated/api';

export type Garden = NonNullable<FunctionReturnType<typeof api.gardens.queries.getGardenById>>;

export type Plant = FunctionReturnType<typeof api.plants.queries.getAllPlants>[number];

export function getPlantCounts(plants: Plant[], gardenPlants: Garden['plants']) {
  const counts: Record<string, number> = {};
  plants.forEach((plant) => {
    counts[plant.id] = 0;
  });

  gardenPlants.forEach((plant) => {
    counts[plant.plantId] = (counts[plant.plantId] || 0) + 1;
  });

  return counts;
}

export function createCellSlotsMap(
  cellSettings?: Array<{ row: number; col: number; slotsPerCell: number }>
) {
  const map = new Map<string, number>();
  (cellSettings || []).forEach((cell) => {
    map.set(`${cell.row}-${cell.col}`, cell.slotsPerCell);
  });
  return map;
}

export function createGetSlotsForCell(cellSlotsMap: Map<string, number>) {
  return (row: number, col: number) => cellSlotsMap.get(`${row}-${col}`) ?? 1;
}

export const getPlantById = (plants: Plant[], id: string): Plant | undefined =>
  plants.find((plant) => plant.id === id);
